<script setup lang="ts">
import { defineProps } from "vue";

defineProps({
    color: {
        type: String,
        default: "var(--color-brand)",
    },
});
</script>

<template>
    <div :style="{ '--color': color }" class="Triangle" />
</template>

<style lang="scss" scoped>
.Triangle {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 46px 12px 0 0;
    border-color: var(--color) transparent transparent transparent;
    transform: rotate(0deg);
}
</style>
